import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { ArrayService, UserService } from '@app/services';
import { ExternalOrgService } from '@app/services/external-org.service';
import { Observable } from 'rxjs';

/**
 * External Organization Guard
 */
@Injectable({
  providedIn: "root",
})
export class ExOrgGuard  {
  private readonly _componentName = 'ExOrgGuard';

  constructor(private router: Router, private userService: UserService, private arrayService: ArrayService, private externalOrgService: ExternalOrgService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.userService.userId === 0) {
      console.warn(`${this._componentName}.canActivate -  Block UserID 0`);
      return false;
    }
    const returnRoute = state.url;

    // MsalGuard should have already sent to login if not authenticated
    
    // Send to default home if user is not part of the external organization
    const failUrlTree = this.router.parseUrl('/');

    let exorgCode = next.paramMap.get('code');

    if (!exorgCode) {

      exorgCode = next.data.exOrgCode;

      if (!exorgCode){
        console.warn(`${this._componentName}.canActivate -  No External Org Code`);

        // go home
        return failUrlTree;
      }
    }

    this.externalOrgService.isCurrentUserMemberOf(exorgCode).subscribe({
      next: isMember => {
        if (isMember) {
          return true;
        } else {
          console.warn(`${this._componentName}.canActivate -  no other conditions met`);
    
          return failUrlTree;
        }
      },
      error: err => {
        console.error(`${this._componentName}.canActivate -  Error checking external org membership: ${err}`);
        return failUrlTree;
      }
    });

  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
